import type { ReactNode } from 'react';

/**
 * Wraps a turn-game board in a size query container that FILLS the race slot,
 * so the board can size itself against `cqw`/`cqh` of its actual slot (never the
 * whole screen). This is scoped to turn boards on purpose: the racing minigames
 * were tuned against the screen-level container, so we must not change their
 * container — only turn boards opt into slot-relative sizing here.
 *
 * The board is centred; nothing scrolls because the board fits both dimensions.
 */
export function TurnBoardFrame({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        containerType: 'size',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      {children}
    </div>
  );
}
